// extracted by mini-css-extract-plugin
export default {"error":"routeError_error__K3C3h"};